module.exports = __webpack_public_path__ + "static/assets/89813a82ff019dc1568e382b05a9a216.svg";